<template>
  <div
    :class="cn(
      'inline-flex items-center rounded-none border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
      variants[variant],
      $attrs.class
    )"
  >
    <slot />
  </div>
</template>

<script>
import { cn } from "@/lib/utils";

export default {
  name: "UiBadge",
  props: {
    variant: {
      type: String,
      default: "default",
    },
  },
  setup() {
    const variants = {
      default: "border-transparent bg-primary text-primary-foreground shadow hover:bg-primary/80",
      secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
      destructive: "border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80",
      outline: "text-foreground",
    };

    return { cn, variants };
  },
};
</script>
